import { useState, useEffect } from 'react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Om oss', href: '#about' },
    { label: 'Tjänster', href: '#services' },
    { label: 'Galleri', href: '#gallery' },
    { label: 'Hitta', href: '#contact' },
  ];

  const handleClick = (e, href) => {
    e.preventDefault();
    setIsMobileMenuOpen(false);
    const element = document.querySelector(href);
    if (element) {
      const offset = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white/95 backdrop-blur-sm shadow-md"
      //    ${
      //   isScrolled
      //     ? 'bg-white/95 backdrop-blur-sm shadow-md'
      //     : 'bg-transparent'
      // }`}
    >
      <div className="container mx-auto">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Desktop Nav - Left */}
          <nav className="hidden md:flex items-center space-x-4 lg:space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleClick(e, link.href)}
                className="text-heading text-xs lg:text-sm hover:text-[var(--color-accent-600)] transition-colors"
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Logo - Center */}
          <a
            href="#home"
            onClick={(e) => handleClick(e, '#home')}
            className="flex items-center absolute left-1/2 transform -translate-x-1/2"
          >
            <h1 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-light tracking-wider whitespace-nowrap">
              Hårgalleriet Selma
            </h1>
          </a>

          {/* CTA - Right */}
          <div className="hidden md:flex items-center">
            <a href="https://www.bokadirekt.se/places/hargalleriet-selma-p-57369" target="_blank" rel="noopener noreferrer">
              <button className="btn text-xs px-4 py-2 lg:px-6 lg:py-3">Boka tid</button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 ml-auto"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <div className="w-6 h-5 flex flex-col justify-between relative">
              <span
                className={`block w-full h-0.5 bg-[var(--color-text-primary)] transition-all duration-300 origin-center ${
                  isMobileMenuOpen ? 'absolute top-1/2 left-0 -translate-y-1/2 rotate-45' : ''
                }`}
              />
              <span
                className={`block w-full h-0.5 bg-[var(--color-text-primary)] transition-all duration-300 ${
                  isMobileMenuOpen ? 'opacity-0' : ''
                }`}
              />
              <span
                className={`block w-full h-0.5 bg-[var(--color-text-primary)] transition-all duration-300 origin-center ${
                  isMobileMenuOpen ? 'absolute top-1/2 left-0 -translate-y-1/2 -rotate-45' : ''
                }`}
              />
            </div>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          isMobileMenuOpen ? 'max-h-96' : 'max-h-0'
        }`}
        style={{ backgroundColor: 'var(--color-bg-primary)' }}
      >
        <nav className="flex flex-col space-y-3 p-4 sm:p-6 border-t border-[var(--color-border-light)]">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => handleClick(e, link.href)}
              className="text-heading text-sm hover:text-[var(--color-accent-500)] transition-colors py-2"
            >
              {link.label}
            </a>
          ))}
          <a href="https://www.bokadirekt.se/places/hargalleriet-selma-p-57369" target="_blank" rel="noopener noreferrer" onClick={() => setIsMobileMenuOpen(false)}>
            <button className="btn w-full text-xs py-3">Boka tid</button>
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
